module.exports = __webpack_public_path__ + "img/big-arrow-white-outline.2eaf57c4.svg";